import React from "react";

import Table from "../../common/Table";
import Option from "../../common/RowOption";
import useParityAccess, { useAccessReady } from "../../common/useParityAccess";

import lbl from "../../../data/Labels.json";

const FinancePaymentsList = ({ activeSem }) => {
  const can = useParityAccess();
  const ready = useAccessReady();
  const allow = (key) => !ready || can(key);
  const paymentsColumn = [
    { path: "id", label: "شماره" },
    { path: "payment_date", label: "تاریخ" },
    { path: "bank_ref_no", label: "ریفرنس نمبر" },
    { path: "account", label: "حساب" },
    { path: "amount", label: "مبلغ" },
    {
      path: "option",
      content: (e) => (
        <Option
          PrintFeeReceipt={allow("print-student-fee-statement") ? { id: e.id, receipt: e } : null}
          Edit={allow("edit-student-fees") ? { form: "student-fee-form", cache: e.student_id, edit: e } : null}
          Delete={allow("delete-student-fees") ? { route: "students/fees", id: e.id } : null}
        />
      ),
    },
  ];

  return (
    <div className="table-card">
      <p className="table-title">{lbl.Payments}</p>
      <Table
        data={activeSem?.payments}
        columns={paymentsColumn}
        total={activeSem?.paid}
      />
    </div>
  );
};

export default FinancePaymentsList;
